import { Component, computed, signal } from '@angular/core';
import { BreadcrumbsComponent } from '../../../ui/admin/breadcrumbs/breadcrumbs.component';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { MediaHistoryTable } from '../../../ui/admin/media-history-table/media-history-table';
import { AzureService } from '../../../../services/azure-service';
import { GenerateAudioPayload, GenerateSingleAudioResult } from '@mira-avant/mtlibs';
import { AudioForm } from '../../../forms/setup-wizard/audio-form/audio-form';
import { UploadComponent } from '../../../ui/upload/upload.component';
import { UploadResult, UploadState } from '../../../../services/metabi-uploader.service';
import { MediaDepotService } from '../../../../services/media-depot-service';

@Component({
	selector: 'app-media',
	imports: [BreadcrumbsComponent, NzTabsModule, AudioForm, MediaHistoryTable, UploadComponent],
	templateUrl: './media.html',
	styleUrl: './media.scss',
})
export class Media {
	public loadingSingle = signal<boolean>(false);
	public loadingBatch = signal<boolean>(false);
	public loading = computed(() => this.loadingSingle() || this.loadingBatch());
	public accept = `
		.zip,.h5p,
		.jpg,.jpeg,.png,.gif,.webp,.svg,.bmp,.tiff,.tif,
		.mp3,.wav,.ogg,.m4a,.aac,.flac,
		.mp4,.webm,.mov,.avi,.mkv,.ogv,
		application/zip,application/x-zip-compressed,application/h5p,
		image/jpeg,image/png,image/gif,image/webp,image/svg+xml,image/bmp,image/tiff,
		audio/mpeg,audio/wav,audio/ogg,audio/mp4,audio/aac,audio/flac,
		video/mp4,video/webm,video/quicktime,video/x-msvideo,video/x-matroska`;

	constructor(
		private azureService: AzureService,
		private mediaDepotService: MediaDepotService
	) {}

	public onSubmitSingle(payload: GenerateAudioPayload) {
		this.loadingSingle.set(true);

		this.azureService
			.generateSingleAudio$(payload)
			.then((result: GenerateSingleAudioResult) => {
				if (result) {
					this.mediaDepotService.addAsset(result.asset);
				}
			})
			.finally(() => {
				this.loadingSingle.set(false);
			});
	}

	public onSubmitBatch(payload: GenerateAudioPayload) {
		this.loadingBatch.set(true);

		this.azureService
			.generateBatchAudio$(payload)
			.then(result => {
				this.mediaDepotService.addAssets(result.assets);
			})
			.finally(() => {
				this.loadingBatch.set(false);
			});
	}

	public onUploadCompleted(event: UploadResult) {
		if (event.progress.state !== UploadState.DONE) {
			console.error('Upload not completed', event);
			return;
		}

		if (!event.result) {
			console.error('No file or files provided in upload event', event);
			return;
		}

		let newUrl: string | undefined = undefined; // = event.file || (event.files && event.files[0]) || '';

		if (event.result && !Array.isArray(event.result)) {
			newUrl = event.result.url;
		}

		if (event.result && Array.isArray(event.result)) {
			newUrl = event.result[0]?.url;
		}

		if (event.result && Array.isArray(event.result) && event.result.length > 0) {
			const h5pJsonFileIfPresent: string | undefined = event.result.find(f => f.url.endsWith('h5p.json'))?.url;

			if (h5pJsonFileIfPresent) {
				newUrl = h5pJsonFileIfPresent.replace('/h5p.json', '.zip');
			}
		}

		//Create new history entry
		if (newUrl) {
			if (Array.isArray(event.result)) {
				this.mediaDepotService.addAssets(event.result);
			} else {
				this.mediaDepotService.addAsset(event.result);
			}
		} else {
			console.error('No new URL could be determined from the upload event', event);
		}
	}
}
